export default {
  newDesign: true,
  title: "¡Recibe una clase gratuita de matemáticas personalizada para tu hijo! | Kodland",
  parameters: {
    landing_id: "LatQMath",
    segment: 10,
  },
  downtimeUrl: "https://cl.kodland.tech",
  startPage: {
    startBackground: "white",
    quizBackground: "#white",
    title:
      "Responde 4 preguntas rápidas y obtén una clase de matemáticas gratis",
    image: {
      url: "/welcome/math_freetc_desktop.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/math_freetc_mob.png",
      style: {
        width: "100%",
      },
    },
    button: " ¡Vamos! ",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "¡Gracias por confiar en nuestra plataforma educativa!",
    subtitle:
      "Desafortunadamente, las tabletas o los teléfonos no son adecuados para tomar nuestras lecciones. ¡Estaremos felices de verlos en nuestras clases la próxima vez!",
  },
  quizRotateBySteps: {
    1: {
      question: "¿Cómo se siente tu hijo respecto a las matemáticas?",
      answers: [
        "💙 ¡Le encantan y está muy entusiasmado/a!",
        "😇 Necesita un pequeño empujón",
        "😔 Tiene dificultades y las evita",
        "🙏 No le interesa, pero quiero cambiar eso",
      ],
    },
    2: {
      question: "¿Cuál es tu prioridad principal en el aprendizaje de matemáticas de tu hijo?",
      answers: [
        "😊 Mantenerlos comprometidos y emocionados",
        "👀 Mostrarles que las matemáticas son esenciales en la vida",
        "📚 Ayudarlos a destacar en la escuela",
        "👍 Liberarlos de los métodos aburridos de siempre",
      ],
    },
    3: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/reviews-latam.png",
      subtitle: " Lo tenemos cubierto. Más de 100.000 padres ya han encontrado apoyo para ayudar a sus hijos a amar las matemáticas, despertar su interés y destacarse en la escuela a través de las lecciones de Kodland.",
      button: "¡Genial! 🔥",
    },
    4: {
      question:
        "¿Qué tan importante es para ti una base académica sólida en el aprendizaje?",
        answers: [
          "🧑‍🎓 Quiero una base académica muy fuerte",
          "🎨 50/50 — Creo que la creatividad también es importante",
          "😊 El compromiso y la alegría son más importantes que los exámenes",
          "🙏 No estoy seguro, pero quiero que estén preparados para el futuro",
        ],
    },
    5: {
      question:
        "¿Qué es lo que más le gusta a tu hijo del aprendizaje?",
        answers: [
          "🎮 Juegos divertidos y actividades prácticas",
          "👨‍🏫 Explicaciones claras y paso a paso",
          "💙 Grupos pequeños con mucha atención personalizada",
          "🔥 Un maestro que los guíe e inspire",
        ],
    },
    6: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/math_kids.webp",
      subtitle: "Entonces, nuestras lecciones de matemáticas harán felices tanto a ti como a tu hijo. Un maestro amable y solidario los guiará de manera divertida y gamificada a través de todo el plan de estudios.",
      button: "Increíble 💙",
    },
    7: {
      question:
        "¿Tienes una computadora de escritorio o portátil con la que tu hijo puedo estudiar?",
      answers: [
        "👍 Sí",
        {
          answer: "👎 No",
          stopAnswer: true,
        },
      ],
    },
    8: {
      title: "¿Qué edad tiene tu hijo/a?",
      type: "age",
      subtitle:
        "Elegiremos el curso más entretenido según la edad de tu hijo/a",
      button: "",
    },
    9: {
      title: "¡Felicitaciones! 🎉",
      typeInfo: "congrats",
      subtitle:
        "Haz clic en '📆 Reservar una clase' para completar el registro",
      button: "📆 Reservar una clase",
    },
    10: {
      title: "Reserva una clase gratuita",
      type: "one-page-contacts",
      subtitle: "",
      button: "Casi terminamos 🔥",
    },
    11: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    12: {
      title:
        "Revisa estos detalles para completar el registro ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Ten en cuenta que para la lección necesitaras una PC o laptop en funcionamiento y que deberás acompañar a tu hijo/a durante toda la clase. Recuerda que la misma es individual y personalizada.",
      button: "¿Qué más?",
    },
    13: {
      title: "Chequea tu correo y WhatsApp antes de la clase de prueba📞",
      typeInfo: "whatsapp",
      subtitle:
        "24hs antes estaremos enviándote un recordatorio y 2 horas antes de la clase te pediremos que confirmes tu asistencia. Es muy importante que estemos en contacto para que la clase no se cancele.",
      button: "¿Qué más?",
    },
    14: {
      title: "La clase se realizará en nuestra plataforma 💻",
      typeInfo: "classroom",
      subtitle:
        "Recibirás un enlace y un código único por WhatsApp y correo electrónico. Solo haz clic en el enlace y te llevará directo a la clase. Sin apps adicionales, sin descargas.",
      button: "Entendido ✅",
    },
  },
};
